import { of as observableOf, Observable } from 'rxjs';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  forwardRef,
  ViewEncapsulation,
  IterableDiffer,
  IterableDiffers,
  ElementRef,
  OnChanges,
  SimpleChanges,
  OnDestroy
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator, AbstractControl, FormsModule } from '@angular/forms';
//import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
//import { IDisableable } from '../shared/IDisableable';
import { BeforeComboChangeArgs } from './before-combo-change-args';
//import { SabisTranslateService } from '../translation/sabis-translate.service';
//import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { SabisTranslateService } from '../translation/sdp-translate.service';
import * as _ from 'lodash';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SelectAllDirective } from './select-all.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'sabis-combobox2',
  templateUrl: './combobox.component.html',
  styleUrls: ['./combobox.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SabisComboBox2Component),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SabisComboBox2Component),
      multi: true,
    },
    //NgProgress
  ],
  imports: [
    MatSelectModule,
    NgxMatSelectSearchModule,
    FormsModule,
    SelectAllDirective,
    TranslatePipe
  ]
})
export class SabisComboBox2Component implements OnInit, OnChanges, OnDestroy, ControlValueAccessor, Validator { // , IDisableable
  @Input('scItems') scItems: any[] | Observable<any[]> = [];
  @Input('scDisplayField') scDisplayField: string = '';
  @Input('scValueField') scValueField: string = '';
  @Input('scLabel') scLabel: string = '';
  @Input('scPlaceholder') scPlaceholder: string = '';
  @Input('scOpenOnFocus') scOpenOnFocus: boolean = true;
  @Input('scOrdered') scOrdered: boolean | string = true;
  @Input('scOrderBy') scOrderBy: string[] = [];
  @Input('scOrderByDirections') scOrderByDirections: ("asc" | "desc")[] = [];// based on columns number which we need to order e.g: ['asc', 'asc', 'desc']
  @Input('scHideValidationMessage') scHideValidationMessage: boolean = false;
  @Input('scInitialValue') scInitialValue: any;
  @Input('scClearButton') scClearButton = true;
  @Input('scAllowCustom') scAllowCustom = false;
  /** Notify for any change, from the UI or internally **/
  @Output('scBeforeChange') scBeforeChange: EventEmitter<BeforeComboChangeArgs> = new EventEmitter<BeforeComboChangeArgs>(false);
  @Input('required') required: boolean = false;
  @Input('scMultiple') scMultiple: boolean = false;
  //@ViewChild('combo', { static: true }) combo: ComboBoxComponent;
  @ViewChild('fakeInput', { static: true }) fakeInput!: ElementRef;

  isOpen: boolean = false;
  isDisabled: boolean = false;
  fieldSetDisabled: boolean = false;
  onChangeCallback: null | ((value: any) => void) = null;
  onTouchedCallback: null | (() => void) = null;
  internalItems: any[] = [];
  scItemsObservable: null | Observable<any[]> = null;
  isItemsLoaded: boolean = true;

  isValid: boolean = true;
  validationMessage: string = '';
  virtual: any = { itemHeight: 28 };
  private _isFirstChange: boolean = true;
  private _internalValue: any;
  private _iterableDiffer: IterableDiffer<{}>;
  private _itemsSubscription: Subscription = new Subscription();

  //progressRef: NgProgressRef;

  get value() {
    if (!this.isItemsLoaded && this.scInitialValue != undefined) {
      return this.scInitialValue;
    }
    return this._internalValue;
  }

  constructor(private _iterableDiffers: IterableDiffers,
    private _translateService: SabisTranslateService //, private ngProgress: NgProgress
  ) {
    this._iterableDiffer = this._iterableDiffers.find([]).create(undefined);
  }

  ngOnInit() {
    //this.progressRef = this.ngProgress.ref();
  }

  ngAfterViewInit() {
    this.selectDefaultItem();
  }

  setDisable(value: boolean): void {
    this.fieldSetDisabled = value;
  }

  ngDoCheck() {
    let changes = this._iterableDiffer.diff(this.internalItems);

    if (changes && this.internalItems) {
      if (this.scOrderBy.length > 0) {
        _.orderBy(this.internalItems, this.scOrderBy, this.scOrderByDirections);
      }
      else if (this.scOrdered === true || this.scOrdered === 'asc') {
        this.internalItems.sort((a, b) => { return (a[this.scDisplayField] > b[this.scDisplayField]) ? 1 : ((b[this.scDisplayField] > a[this.scDisplayField]) ? -1 : 0); });
      }
      else if (this.scOrdered === 'desc') {
        this.internalItems.sort((a, b) => { return (a[this.scDisplayField] < b[this.scDisplayField]) ? 1 : ((b[this.scDisplayField] < a[this.scDisplayField]) ? -1 : 0); });
      }
    }
  }

  private selectDefaultItem() {
    setTimeout(() => {
      if (!this._internalValue && Array.isArray(this.scItems) && (typeof (this.required) == "string" || this.required === true) && this.scItems.length == 1) {
        const defaultItemId = this.scItems[0][this.scValueField];
        this.onComboValueChange(defaultItemId);
        this._internalValue = defaultItemId;
      }
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    const scItemsChange = changes['scItems'];
    if (scItemsChange && this.scItems) {
      if (Array.isArray(this.scItems)) {
        this.internalItems = this.scItems;
        this.isItemsLoaded = true;
      } else {
        this.scItemsObservable = this.scItems;
        this.isItemsLoaded = false;
        this.internalItems = [];
      }
      this.selectDefaultItem();
    }
  }

  ngOnDestroy(): void {
    //if (this.progressRef.isStarted) {
    //  this.progressRef.destroy();
    //}

    if (this._itemsSubscription) {
      this._itemsSubscription.unsubscribe();
    }
  }

  /**
   * Update the view with new value, onChange will not be called
   * @param obj
   */
  writeValue(obj: any): void {
    if (this.value !== obj) {
      this._internalValue = obj;
    }
    this.selectDefaultItem();
  }

  /**
   * kendo combo value has changed
   * view -> model
   * @param value
   */
  onComboValueChange(value: any) {
    if (!this.internalItems || (this.internalItems && this.internalItems.length === 0)) {
      value = null;
    }
    const oldValue = this._internalValue;
    this._internalValue = typeof (value) != 'undefined' ? value : null;

    if ((oldValue !== this._internalValue)) {
      // before change args
      const args: BeforeComboChangeArgs = {
        newValue: value,
        item: this.internalItems.find(i => i[this.scValueField] === value),
        continue: observableOf(true)
      };
      this.scBeforeChange.emit(args);

      args.continue.subscribe(proceed => {
        if (proceed) {
          if (this.onChangeCallback) {
            this.onChangeCallback(this._internalValue);
          }
        } else {
          // restore old value
          this._internalValue = oldValue;
        }
      });
    }
  }

  onOpen() {
    this.isOpen = true;

    this.loadOnDemand();

  }

  /**
   * When the value changes in the UI, call the registered
   * function to allow the forms API to update itself
   * @param fn
   */
  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
    this.selectDefaultItem();
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  /**
   * Auto open has focused
   */
  onComboFocus() {
    if (this.onTouchedCallback) {
      this.onTouchedCallback();
    }
    if (this.scOpenOnFocus === true && !this.value) {
      //this.combo.toggle(true);
      this.loadOnDemand();
    }
  }

  onEnterClicked(event: any) {
    if (event.keyCode == 13 && !this.isOpen) {
      //this.combo.toggle(true);
      this.loadOnDemand();
    }
  }

  onComboClose() {
    this.isOpen = false;
  }

  validate(c: AbstractControl): { [key: string]: any; } {
    this.setValidationMessage(c);
    return {};
  }
  registerOnValidatorChange?(fn: () => void): void {

  }
  private setValidationMessage(c: AbstractControl): void {
    // set Time out because the control changes validation after passing in the validate function
    setTimeout(() => {
      this.isValid = c.errors == null;
      if (!this.isValid) {
        for (var e in c.errors) {
          if (e == 'required') {
            this.validationMessage = this._translateService.instant('SabisComponents.FieldRequired');
          }
          else {
            this.validationMessage = '';
          }
        }
      }
    });
  }

  loadOnDemand() {
    if (this.scItemsObservable && !this.isItemsLoaded) {
      this.internalItems = [];
      //this.progressRef.start()
      if (this._itemsSubscription) {
        this._itemsSubscription.unsubscribe();
      }

      this._itemsSubscription = this.scItemsObservable.subscribe((items) => {
        this.internalItems = items || [];
        this.isItemsLoaded = true;
        //this.progressRef.complete();
      });
    }
  }

  /** Get displayed value from ComboBox. Returns string value or null if unable to get one */
  public getDisplayText(): string | null {
    if (this.value === undefined || this.scValueField === undefined || this.scDisplayField === undefined) {
      return null;
    }

    const selectedItem = this.internalItems.find(x => x[this.scValueField] === this.value);

    if (selectedItem === undefined) {
      return null;
    }

    return selectedItem[this.scDisplayField];
  }

  protected onComboOptionsSearchChange(searchText: string): void {
    // If not an Array -> scItems will not be assignable to other variables
    if (!Array.isArray(this.scItems)) {
      return;
    }

    if (!searchText) {
      this.internalItems = this.scItems;

      return;
    }

    // filter items
    searchText = searchText.toLowerCase();
    this.internalItems = this.scItems.filter(item => item[this.scDisplayField].toLowerCase().includes(searchText))
  }
}



